import { css } from "@emotion/css";
import { borderRadius, borderWidth, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
/** TextField and Textarea shared input styles */
export const inputStyles = css({
    font: text.body.regular.large,
    boxSizing: "border-box",
    padding: space[8],
    border: `${borderWidth[1]} solid ${themeTokens.color.border.bold}`,
    borderRadius: borderRadius.small,
    backgroundColor: themeTokens.color.background.primary.default,
    color: themeTokens.color.text.primary,
    width: "100%",
    "&:focus-visible": {
        outline: `${borderWidth[2]} solid ${themeTokens.color.border.selected}`,
        outlineOffset: "0",
        borderColor: themeTokens.color.border.selected,
    },
    "&::placeholder": {
        color: themeTokens.color.text.tertiary,
    },
});
export const inputErrorStyles = css({
    borderColor: themeTokens.color.border.danger,
    "&:focus": {
        borderColor: themeTokens.color.border.danger,
        outline: `${borderWidth[2]} solid ${themeTokens.color.border.danger}`,
    },
});
export const inputDisabledStyles = css({
    backgroundColor: themeTokens.color.background.disabled,
    color: themeTokens.color.text.secondary,
    cursor: "not-allowed",
    "&::placeholder": {
        color: themeTokens.color.text.secondary,
    },
});
export const inputReadOnlyStyles = css({
    backgroundColor: themeTokens.color.background.secondary.default,
});
